import { createContext } from "react";

interface ChainIdContextType {
  chainId?: number;
}

export const ChainIdContext = createContext<ChainIdContextType>(
  {} as ChainIdContextType,
);
